import RatingSelector from './RatingSelector.jsx';

export default function ProofImageGrid({ images, onOpen, onRate, admin = false, onDelete }) {
  if (!images.length) {
    return (
      <div className="proof-empty">
        <p className="mono-label">No frames</p>
        <h3>Hier ist noch kein Bild in diesem Status.</h3>
      </div>
    );
  }

  return (
    <div className="proof-grid">
      {images.map((image) => (
        <article className={`proof-card ${image.orientation || 'landscape'} ${image.rating || 'unrated'}`} key={image.id}>
          <button type="button" className="proof-card__image" onClick={() => onOpen?.(image)}>
            <img src={image.thumbSrc} alt={image.filename} loading="lazy" decoding="async" />
            <span className={`proof-card__status ${image.rating || 'unrated'}`}>{image.rating || 'unrated'}</span>
          </button>
          <div className="proof-card__meta">
            <p>{image.filename}</p>
            <span>{image.orientation}</span>
          </div>
          <RatingSelector value={image.rating} onChange={(rating) => onRate?.(image, rating)} compact />
          {admin && (
            <div className="proof-card__admin">
              <button type="button" onClick={() => onRate?.(image, image.rating === 'final' ? null : 'final')}>
                {image.rating === 'final' ? 'Unfinal' : 'Als final'}
              </button>
              <button type="button" className="danger" onClick={() => onDelete?.(image)}>
                Löschen
              </button>
            </div>
          )}
        </article>
      ))}
    </div>
  );
}
